import { createApp } from 'vue'
import { createPinia } from 'pinia'

const pinia = createPinia();

import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);

import App from './App.vue'
import router from './router'
import AudioPlayer from '@liripeng/vue-audio-player'
import CKEditor from '@ckeditor/ckeditor5-vue';

const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(AudioPlayer)
app.use(CKEditor)
app.mount('#app')
